define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.indexOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/indexOf.js
// module id = 264
// module chunks = 259